import CardIndex from './CardIndex';

export default CardIndex;
